export default import.meta.env.VITE_ENV